import { motion } from "framer-motion";
import { useLang } from "@/lib/i18n";

export const Process = () => {
  const { t } = useLang();

  return (
    <section
      id="process"
      data-testid="process-section"
      className="relative isolate overflow-hidden bg-[color:var(--paper)] py-24 sm:py-32"
    >
      <div className="mx-auto max-w-[1200px] px-6 lg:px-10">
        <div className="mb-14 flex items-baseline gap-6">
          <span className="eyebrow">{t.process.eyebrow}</span>
          <div className="hairline-rule flex-1" />
        </div>

        <div className="grid grid-cols-1 gap-16 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.9 }}
              viewport={{ once: true, margin: "-100px" }}
              data-testid="process-headline"
              className="font-display text-[28px] leading-[1.1] text-[color:var(--ink)] sm:text-[36px] lg:text-[44px]"
            >
              {t.process.title_a}{" "}
              <span className="font-serif-accent italic text-[color:var(--emerald)]">
                {t.process.title_em}
              </span>
            </motion.h2>
            <p className="mt-6 max-w-sm text-[15px] leading-relaxed text-[color:var(--ink-3)]">
              {t.process.sub}
            </p>
          </div>

          <ol className="relative lg:col-span-7">
            <span
              aria-hidden="true"
              className="absolute left-[11px] top-2 bottom-2 w-px bg-[color:var(--rule-strong)]"
            />
            {t.process.steps.map((s, idx) => (
              <motion.li
                key={idx}
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, delay: 0.06 * idx }}
                viewport={{ once: true, margin: "-80px" }}
                data-testid={`process-step-${idx + 1}`}
                className="relative pl-14 pb-12 last:pb-0"
              >
                <span
                  aria-hidden="true"
                  className="absolute left-0 top-1 inline-flex h-[22px] w-[22px] items-center justify-center rounded-full border border-[color:var(--rule-strong)] bg-[color:var(--paper)]"
                >
                  <span className="h-2 w-2 rounded-full bg-[color:var(--gold)]" />
                </span>

                <div className="flex items-baseline gap-3">
                  <span className="font-mono-accent text-[10px] uppercase tracking-[0.22em] text-[color:var(--muted)]">
                    {String(idx + 1).padStart(2, "0")}
                  </span>
                  <span className="h-px flex-1 bg-[color:var(--rule)]" />
                </div>

                <h3 className="font-display mt-3 text-[22px] leading-tight text-[color:var(--ink)] sm:text-[26px]">
                  {s.title}
                </h3>
                <p className="mt-2 max-w-lg text-[15px] leading-relaxed text-[color:var(--ink-3)]">
                  {s.desc}
                </p>
              </motion.li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
};
